import React from 'react';
import styled from 'styled-components';
import uuid from 'uuid';

import { InputWithBorder } from 'components/molecules/TextInput';
import { Body2, ButtonText, Icon } from 'ensightful-koala-ui';

const StyledInputWithBorder = styled(InputWithBorder)`
    min-width: 0px;
    padding-bottom: 0px;
    padding-top: 0px;

    & p {
        margin: 0px;
    }
`;

const TableContainer = styled.table`
    display: table;
    width: 100%;
`;
const HeaderContainer = styled.thead`
    display: table-header-group;
    border-bottom: 1px solid #e0e0e0;
`;
const BodyContainer = styled.tbody``;
const FooterContainer = styled.tfoot`
    display: ${(props) => (props.review ? 'none' : 'table-footer-group')};
    border-top: 1px solid #e0e0e0;
`;

const TableRow = styled.tr`
    vertical-align: middle;
    width: 100%;
`;

const TableCell = styled.td`
    padding: 5px 2px 5px 2px;
`;

const AddMemberContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;

    & svg {
        width: 15px;
        height: 15px;
        margin-right: 8px;
    }

    & svg path {
        fill: #6347ff;
    }

    &:hover {
        cursor: pointer;
    }
`;

const EmptyTableCell = styled.td``;

const NumberTableCell = styled(TableCell)`
    width: 5%;
`;

const InputTableCell = styled(TableCell)`
    width: ${(props) => (props.isWithTeam ? '23%' : '40%')};
`;

const TrashCanTableCell = styled(TableCell)`
    width: 5%;

    &:hover {
        cursor: pointer;
    }
`;

const TableHeader = styled.th`
    width: ${(props) => (props.isWithTeam ? '23%' : '40%')};
`;

const RenderUsers = ({ isWithTeam = false, userList = [], handleInputChange, removeRow }) => {
    return userList.map((user, index) => (
        <TableRow key={user.id}>
            <NumberTableCell>
                <Body2>{index + 1}</Body2>
            </NumberTableCell>
            <InputTableCell isWithTeam={isWithTeam}>
                <StyledInputWithBorder
                    error={false}
                    errorMessage=''
                    placeholder=''
                    required={false}
                    value={user.email}
                    onChange={(value) => handleInputChange(index, 'email', value)}
                    title={''}
                />
            </InputTableCell>
            <InputTableCell isWithTeam={isWithTeam}>
                <StyledInputWithBorder
                    error={false}
                    errorMessage=''
                    placeholder=''
                    required={false}
                    value={user.name}
                    onChange={(value) => handleInputChange(index, 'name', value)}
                    title={''}
                />
            </InputTableCell>
            {isWithTeam && (
                <InputTableCell isWithTeam={isWithTeam}>
                    <StyledInputWithBorder
                        error={false}
                        errorMessage=''
                        placeholder=''
                        required={false}
                        value={user.team}
                        onChange={(value) => handleInputChange(index, 'team', value)}
                        title={''}
                    />
                </InputTableCell>
            )}
            <TrashCanTableCell>
                <Icon onClick={() => removeRow(user.id)} kind={'trashCan'} />
            </TrashCanTableCell>
        </TableRow>
    ));
};

const AddUserTable = ({
    type,
    userList = [{ id: uuid.v4(), email: '', name: '', team: '' }],
    addMoreUser,
    isWithTeam = false,
    handleInputChange,
    review = false,
}) => {
    const convertInputChanges = (index, key, data) => {
        if (!userList || !userList[index]) return;
        const updatedUserList = userList.map((user, userIndex) => {
            if (index === userIndex) {
                return { ...user, [key]: data };
            }
            return user;
        });
        return handleInputChange(type, updatedUserList);
    };

    const removeRow = (id) => {
        const updatedUserList = userList.filter((user) => user.id !== id);
        return handleInputChange(type, updatedUserList);
    };

    return (
        <TableContainer>
            <HeaderContainer>
                <TableRow>
                    <EmptyTableCell />
                    <TableHeader isWithTeam={isWithTeam}>
                        <Body2> Email</Body2>
                    </TableHeader>
                    <TableHeader isWithTeam={isWithTeam}>
                        <Body2> Name (Optional)</Body2>
                    </TableHeader>
                    {isWithTeam && (
                        <TableHeader isWithTeam={isWithTeam}>
                            <Body2> Team</Body2>
                        </TableHeader>
                    )}
                </TableRow>
            </HeaderContainer>
            <BodyContainer>
                <RenderUsers
                    userList={userList}
                    isWithTeam={isWithTeam}
                    handleInputChange={convertInputChanges}
                    removeRow={removeRow}
                />
            </BodyContainer>
            <FooterContainer review={review}>
                <TableRow>
                    <EmptyTableCell />
                    <TableCell colSpan={'2'}>
                        <AddMemberContainer
                            onClick={() => addMoreUser({ id: uuid.v4(), email: '', name: '', team: '' })}
                        >
                            <Icon kind={'plus'} />
                            <ButtonText style={{ color: '#6347ff' }}> Add A Member</ButtonText>
                        </AddMemberContainer>
                    </TableCell>
                </TableRow>
            </FooterContainer>
        </TableContainer>
    );
};

export default AddUserTable;
